import DocumentPagingResultModelBase from '../_generated/modelBases/document-paging-result-model-base';

export default class DocumentPagingResultModel extends DocumentPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
